import React from 'react';
import s from "./Links.css";
import LoadingState from '../LoadingState';
import { isEmpty } from 'ramda';
import PropTypes from 'prop-types';

const Links = ({isLoading, data = {}, action}) => {
  if (isLoading) {
    return (
        <div className={s.message}>
          <p>
            Loading your Links...
          </p>
          <LoadingState context="links" />
        </div>
    );
  } else if (!isEmpty(data) && !isEmpty(data["links"])) {
      return (
          <div>
              <section className={s.component}>
                  <h3 className={s.header}>Links</h3>
                  <ul className={s.list}>
                      {data["links"].map(link =>
                         <li key={link.title}><a className={s.action} onClick={() => action(link.callee) }>{link.title}</a></li>
                      )}
                  </ul>
              </section>
          </div>
      );
  } else {
      return (<div/>)
  }
};

Links.propTypes = {
    isLoading: PropTypes.bool,
    data: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
    action: PropTypes.func,
}

export default Links;



// WEBPACK FOOTER //
// ./src/components/Links/Links.js